// component defintion

import * as React from "react";
import { useTheme, Box, Typography, useMediaQuery, Stack } from "@mui/material";
import open from "../images/opensource.png";

const OpenSource = ({}) => {
  const theme = useTheme();

  const smallScreen = useMediaQuery(theme.breakpoints.down(600));

  const openContributions = [
    {
      title: "Mongo Versions Snapshot",
      link: "https://www.npmjs.com/package/mongo-snapshot",
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        bgcolor: theme.palette.common.black,
      }}
    >
      <Stack
        direction="row"
        sx={{
          width: "100%",
          py: "2rem",
          justifyContent: "center",
        }}
      >
        <img
          src={open}
          alt="opensource"
          style={{
            height: smallScreen ? "75px" : "200px",
            marginRight: "1rem",
          }}
        />
        <Stack
          direction={"column"}
          sx={{
            alignItems: "flex-start",
          }}
        >
          <Typography
            sx={{
              fontFamily: "'Oswald', sans-serif",
              fontWeight: 700,
              fontSize: smallScreen ? "18px" : "32px",
              color: theme.palette.common.white,
              textAlign: "left",
              //px: "10vw",
              mb: "1rem",
            }}
          >
            Open source contributions
          </Typography>
          <Stack
            direction={"row"}
            sx={{
              alignItems: "center",
              justifyContent: "flex-start",
              flexWrap: "wrap",
            }}
          >
            {openContributions?.map((target) => {
              return (
                <a
                  href={target?.link}
                  style={{
                    textDecoration: "none",
                    cursor: "pointer",
                    mr: "0.5rem",
                  }}
                >
                  <Typography
                    sx={{
                      py: "0.2rem",
                      px: "0.5rem",
                      bgcolor: theme.palette.common.black,
                      boxShadow:
                        "0px 8px 28px -6px rgba(24, 39, 75, 0.12), 0px 18px 88px -4px rgba(24, 39, 75, 0.14)",
                      borderRadius: "3rem",
                      mb: "0.5rem",
                      minWidth: "max-content",
                      color: theme.palette.common.white,
                      fontSize: "12px",
                      border: `1px solid ${theme.palette.common.white}`,
                    }}
                  >
                    {target?.title}
                  </Typography>
                </a>
              );
            })}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};

export default OpenSource;
